import { EnterAnimationStartEvent } from '@mockly/events'
import scrollLock from '@mockly/scroll-lock';

const darkPaths = [
  /^\/collections\/[^\/]+\/?$/,
  /^\/pages\/(?!reviews$|press$|about$)[^\/]+\/?$/,
]

const selectors = {
  toggle: '[data-mobile-menu-toggle]',
  close: '[data-mobile-menu-close]',
  navLinks: 'a.nav-link'
}

class ComponentSiteHeader extends HTMLElement {
  #mobileMenuOpen = false;
  
  constructor() {
    super();

    this.onPageChange = this.onPageChange.bind(this);
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.openMobileMenu = this.openMobileMenu.bind(this);
    this.closeMobileMenu = this.closeMobileMenu.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    
    this.onPageChange();
  }

  handleResize() {
    if (window.innerWidth > 800 && this.#mobileMenuOpen) {
      this.closeMobileMenu();
    }
  }

  handleKeyDown(e) {
    if ((e.key === 'Escape' || e.key === 'Home') && this.#mobileMenuOpen) {
      this.closeMobileMenu();
    }
  }

  toggleMobileMenu() {
    if (this.#mobileMenuOpen) {
      this.closeMobileMenu();
    } else {
      this.openMobileMenu();
    }
  }
  
  openMobileMenu() {
    this.#mobileMenuOpen = true;
    this.setAttribute('data-mobile-menu-open', this.#mobileMenuOpen);
    scrollLock.lock();
  }
  
  closeMobileMenu() {
    this.#mobileMenuOpen = false;
    this.setAttribute('data-mobile-menu-open', this.#mobileMenuOpen);
    scrollLock.unlock();
  }

  updateNavLinks() {
    this.navLinks?.forEach(link => {
      const path = link.getAttribute('href');
      const isActive = path === this.currentPath;
      link.setAttribute('data-active', isActive);
    })
  }

  onPageChange() {
    this.currentPath = window.location.pathname;
    this.updateNavLinks();
    
    const isDark = darkPaths.some(path => path.test(this.currentPath));
    
    this.theme = isDark ? 'dark' : 'light';

    this.setAttribute('data-theme', this.theme);
  }

  connectedCallback() {
    this.toggle = this.querySelector(selectors.toggle);
    this.close = this.querySelector(selectors.close);
    this.navLinks = this.querySelectorAll('a.nav-link');

    this.updateNavLinks();
    
    this.toggle.addEventListener('click', this.toggleMobileMenu);
    this.close?.addEventListener('click', this.closeMobileMenu);
    this.navLinks?.forEach(link => {
      link.addEventListener('click', this.closeMobileMenu);
    });

    window.addEventListener('resize', this.handleResize);
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener(EnterAnimationStartEvent.eventName, this.onPageChange);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.toggleMobileMenu);
    this.close?.removeEventListener('click', this.closeMobileMenu);
    this.navLinks?.forEach(link => {
      link.removeEventListener('click', this.closeMobileMenu);
    });

    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener(EnterAnimationStartEvent.eventName, this.onPageChange);
  }
}

if (!customElements.get('site-header')) {
  customElements.define('site-header', ComponentSiteHeader);
}